/* ============================================================================
   assets/ll-pokemon-hub.js
   The behaviour for sections/ll-pokemon-hub.liquid.
   ============================================================================

   This used to be an inline <script> in the section. Inline meant it was part
   of the HTML document: re-rendered by Shopify and re-sent to the browser on
   every single page view, never cached, and counted against the time the
   server spends building the page. On the homepage the six hub sections came
   to 127 KB of the 1.8 MB document.

   The code is byte-identical on every render, so it belongs in an asset the
   browser can cache once and reuse across the whole site.

   WHAT CHANGED, AND WHAT DID NOT. The section used to bake its own id into the
   script as `var ROOT_ID = "{{ uid }}"`, which is the single reason this could
   not be a static file. One asset now serves every instance: it finds each
   root by its [data-lltc-root] marker and reads the id from
   data-section-id, which the markup already carried. Everything inside
   initInstance is the original code, unchanged.

   The per-instance JSON config block stays in the section, because that is
   real per-instance data rather than code.
============================================================================ */
(function () {
  /* Two instances of the same section put two identical <script src> tags on
     the page, and the browser runs both. */
  if (window.__llPokemonHubJS) return;
  window.__llPokemonHubJS = true;

  /* ---- block 1 of 2, extracted verbatim ---- */
  (function () {
    var inited = {};

    function initInstance(ROOT_ID) {
      function boot(root) {
          if (!root || root.dataset.lltcReady === '1') return;
          root.dataset.lltcReady = '1';

          var cfg = {};
          try { cfg = JSON.parse(root.querySelector('[data-lltc-config]').textContent); } catch (e) { cfg = {}; }

          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var live = root.querySelector('[data-live]');
          var observers = [];
          var railUpdaters = [];

          var K_AFF = 'll_tcg_affinity';
          var K_LAST = 'll_tcg_last';
          var K_RV = 'll_recently_viewed';
          /* One watchlist across the whole storefront, so a card saved here is the
             same list the pre-order hub shows. */
          var K_WATCH = 'll_watchlist';

          function say(m) { if (live) live.textContent = m; }
          function readJSON(store, key, fallback) {
            try { var v = store.getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; }
          }
          function writeJSON(store, key, val) {
            try { store.setItem(key, JSON.stringify(val)); } catch (e) {}
          }

          /* ---------------- toast ---------------- */
          var toast = root.querySelector('[data-toast]');
          var toastText = root.querySelector('[data-toast-text]');
          var toastLink = root.querySelector('[data-toast-link]');
          var toastTimer = null;
          function showToast(msg, href, linkText) {
            if (!toast) return;
            toastText.textContent = msg;
            if (toastLink) {
              /* An empty linkText now means "no link" rather than falling back to
                 View cart - removing the last watched item should not send someone
                 to an empty watchlist. */
              if (linkText === '') {
                toastLink.hidden = true;
              } else {
                toastLink.hidden = false;
                toastLink.href = href || cfg.cartUrl || '/cart';
                toastLink.textContent = linkText || 'View cart';
              }
            }
            toast.classList.add('is-on');
            clearTimeout(toastTimer);
            toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 4000);
            say(msg);
          }

          var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
          var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));

          /* =====================================================================
             WATCHLIST - device-local, shared with the pre-order hub
          ===================================================================== */
          var watchChip = root.querySelector('[data-watch-chip]');
          var watchCount = root.querySelector('[data-watch-count]');
          var laneFilters = [];          /* each lane registers its re-filter here */

          function readWatch() {
            var list = readJSON(localStorage, K_WATCH, null);
            if (Object.prototype.toString.call(list) === '[object Array]') return list;
            /* One-time migration from the pre-order hub's original key. */
            var old = readJSON(localStorage, 'll_preorder_watch', []);
            if (Object.prototype.toString.call(old) === '[object Array]' && old.length) {
              writeWatch(old);
              return old;
            }
            return [];
          }
          function writeWatch(list) {
            var clean = (list || []).slice(0, 100);
            writeJSON(localStorage, K_WATCH, clean);
            writeJSON(localStorage, 'll_preorder_watch', clean);
            var cid = root.getAttribute('data-customer-id');
            if (cid) writeJSON(localStorage, 'll_watchlist_c_' + cid, clean);
            try {
              document.dispatchEvent(new CustomEvent('ll:watchlist:change', { detail: { list: clean } }));
            } catch (e) {}
            return clean;
          }
          function unwatchHandle(handle) {
            var list = readWatch().filter(function (h) { return h !== handle; });
            writeWatch(list);
            try {
              var snaps = readJSON(localStorage, 'll_watchlist_snap', {});
              if (snaps && typeof snaps === 'object') {
                delete snaps[handle];
                writeJSON(localStorage, 'll_watchlist_snap', snaps);
              }
            } catch (e) {}
            if (window.LLWatchlistLive && typeof window.LLWatchlistLive.stop === 'function') {
              window.LLWatchlistLive.stop(handle);
            }
            return list;
          }

          function paintWatch() {
            var list = readWatch();
            root.querySelectorAll('[data-card]').forEach(function (card) {
              var bell = card.querySelector('[data-watch]');
              if (!bell) return;
              var on = list.indexOf(card.getAttribute('data-handle')) > -1;
              bell.setAttribute('aria-pressed', on ? 'true' : 'false');
              /* The bell used to keep saying "Add ... to your watchlist" after it had
                 been saved, so the only feedback was a colour change. Swap the label
                 so the control states what it will do next, as it does elsewhere. */
              var next = bell.getAttribute(on ? 'data-watch-remove' : 'data-watch-add');
              if (next) {
                bell.setAttribute('aria-label', next);
                bell.setAttribute('title', next);
              }
            });
            if (watchChip) {
              watchChip.hidden = list.length === 0;
              watchChip.setAttribute('data-has', list.length ? '1' : '0');
              if (watchCount) watchCount.textContent = list.length;
              if (!list.length) watchChip.setAttribute('aria-pressed', 'false');
            }
          }

          root.addEventListener('click', function (e) {
            var bell = e.target.closest('[data-watch]');
            if (!bell || !root.contains(bell)) return;
            e.preventDefault();
            e.stopPropagation();
            var card = bell.closest('[data-card]');
            var handle = card.getAttribute('data-handle');
            var list = readWatch();
            var at = list.indexOf(handle);
            if (at > -1) {
              unwatchHandle(handle); paintWatch();
              if (watchViewOpen()) renderWatchView();
              /* Removing used to announce to screen readers only, so a sighted
                 shopper got no confirmation at all. Same toast treatment as adding,
                 minus the link when the list is now empty. */
              var left = readWatch().length;
              showToast(
                cfg.watchRemoved || 'Removed from your watchlist',
                cfg.watchUrl || '/pages/watchlist',
                left ? (cfg.watchLinkLabel || 'View watchlist') : ''
              );
              say(cfg.watchRemoved || 'Removed from your watchlist');
            } else {
              list.unshift(handle);
              writeWatch(list); paintWatch();
              bumpAffinity(gameOfCard(card), 2);
              showToast(
                cfg.watchAdded || 'Saved to your watchlist',
                cfg.watchUrl || '/pages/watchlist',
                cfg.watchLinkLabel || 'View watchlist'
              );
            }
          });

          /* One-time watchlist tip across the whole storefront. */
          var K_TIP = 'll_watchlist_tip_seen';
          var tipEl = root.querySelector('[data-watch-tip]');
          var tipDismiss = root.querySelector('[data-watch-tip-dismiss]');
          function tipSeen() {
            try { return localStorage.getItem(K_TIP) === '1'; } catch (e) { return true; }
          }
          function hideAllTips() {
            document.querySelectorAll('[data-watch-tip]').forEach(function (el) { el.hidden = true; });
          }
          function markTipSeen() {
            try { localStorage.setItem(K_TIP, '1'); } catch (e) {}
            hideAllTips();
            try { document.dispatchEvent(new CustomEvent('ll:watchlist:tip-dismissed')); } catch (e) {}
          }
          if (tipEl && !tipSeen()) tipEl.hidden = false;
          if (tipDismiss) tipDismiss.addEventListener('click', markTipSeen);
          document.addEventListener('ll:watchlist:tip-dismissed', hideAllTips);

          function refilterAll() { laneFilters.forEach(function (f) { f(); }); }

          /* =====================================================================
             WATCHLIST VIEW
             Built from the saved handles rather than from what happens to be on the
             page, so a watched card shows up even when no lane here contains it.
          ===================================================================== */
          var wv = root.querySelector('[data-watch-view]');
          var wvGrid = root.querySelector('[data-watch-grid]');
          var wvEmpty = root.querySelector('[data-wv-empty]');
          var wvCount = root.querySelector('[data-wv-count]');
          var wvClose = root.querySelector('[data-wv-close]');
          var currentTab = 0;

          function money(cents) {
            var v = (Number(cents) || 0) / 100;
            try {
              return new Intl.NumberFormat(document.documentElement.lang || 'en-GB',
                { style: 'currency', currency: cfg.currency || 'GBP' }).format(v);
            } catch (e) { return v.toFixed(2); }
          }
          function rootUrl() {
            return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          }

          /* Cached briefly - reopening the panel should not re-hit the network. */
          function fetchProduct(handle) {
            var key = 'll_wv_' + handle;
            var hit = readJSON(sessionStorage, key, null);
            if (hit && hit.t && (Date.now() - hit.t) < 600000) return Promise.resolve(hit.p);
            return fetch(rootUrl() + 'products/' + handle + '.js')
              .then(function (r) { if (!r.ok) throw new Error('gone'); return r.json(); })
              .then(function (p) { writeJSON(sessionStorage, key, { t: Date.now(), p: p }); return p; });
          }

          function wvCard(p) {
            var el = document.createElement('article');
            el.className = 'lltc__card';
            el.setAttribute('data-card', '');
            el.setAttribute('data-handle', p.handle);
            el.setAttribute('data-url', rootUrl() + 'products/' + p.handle);
            el.setAttribute('data-title', p.title || '');

            var variant = null;
            for (var i = 0; i < (p.variants || []).length; i++) {
              if (p.variants[i].available) { variant = p.variants[i]; break; }
            }
            if (variant) el.setAttribute('data-vid', variant.id);
            var multi = (p.variants || []).length > 1;
            el.setAttribute('data-multi', multi ? 'true' : 'false');

            var img = p.featured_image || (p.images && p.images[0]) || '';
            if (img && img.indexOf('//') === 0) img = 'https:' + img;
            var url = rootUrl() + 'products/' + p.handle;

            var cta;
            if (!p.available) {
              cta = '<a class="lltc__btn lltc__btn--ghost" href="' + url + '"><span class="lltc__btn-t">' +
                (cfg.soldOutLabel || 'Sold out') + '</span></a>';
            } else if (multi) {
              cta = '<a class="lltc__btn lltc__btn--ghost" href="' + url + '"><span class="lltc__btn-t">' +
                (cfg.optionsLabel || 'Choose options') + '</span></a>';
            } else {
              cta = '<button type="button" class="lltc__btn" data-add>' +
                '<span class="lltc__btn-t">' + (cfg.addLabel || 'Add') + '</span></button>';
            }

            el.innerHTML =
              '<a class="lltc__media" href="' + url + '" tabindex="-1" aria-hidden="true">' +
                (img ? '<img class="is-main" src="' + img + '" alt="" width="360" height="360" loading="lazy" decoding="async">' : '') +
              '</a>' +
              '<div class="lltc__body">' +
                '<h4 class="lltc__name"><a href="' + url + '"></a></h4>' +
                '<span class="lltc__price">' + money(p.price) + '</span>' +
              '</div>' +
              '<div class="lltc__cta">' + cta +
                '<button type="button" class="lltc__bell" data-watch aria-pressed="true" aria-label="Remove from watchlist">' +
                '' +
                '</button>' +
              '</div>';
            /* textContent, not innerHTML - a product title is untrusted markup. */
            el.querySelector('.lltc__name a').textContent = p.title || p.handle;
            var im = el.querySelector('img');
            if (im) im.alt = p.title || '';
            return el;
          }

          function renderWatchView() {
            if (!wv || !wvGrid) return;
            var list = readWatch();
            if (wvCount) wvCount.textContent = list.length;
            wvGrid.innerHTML = '';
            if (!list.length) {
              if (wvEmpty) wvEmpty.setAttribute('data-show', '1');
              return;
            }
            if (wvEmpty) wvEmpty.setAttribute('data-show', '0');
            wvGrid.innerHTML = '<p class="lltc__wv-skel">Loading your saved cards…</p>';

            Promise.all(list.slice(0, 24).map(function (h) {
              return fetchProduct(h).catch(function () { return null; });
            })).then(function (items) {
              wvGrid.innerHTML = '';
              var gone = [];
              var shownAny = 0;
              items.forEach(function (p, i) {
                if (!p) { gone.push(list[i]); return; }
                wvGrid.appendChild(wvCard(p));
                shownAny++;
              });
              /* Prune anything that no longer exists so the count stays truthful. */
              if (gone.length) {
                var kept = readWatch().filter(function (h) { return gone.indexOf(h) === -1; });
                writeWatch(kept);
                paintWatch();
                if (wvCount) wvCount.textContent = kept.length;
              }
              if (!shownAny && wvEmpty) wvEmpty.setAttribute('data-show', '1');
            });
          }

          function openWatchView() {
            if (!wv) return;
            wv.hidden = false;
            panels.forEach(function (p) { p.hidden = true; });
            if (watchChip) watchChip.setAttribute('aria-pressed', 'true');
            renderWatchView();
            say('Showing your watchlist');
            wv.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
          }
          function closeWatchView() {
            if (!wv) return;
            wv.hidden = true;
            if (watchChip) watchChip.setAttribute('aria-pressed', 'false');
            if (tabs.length) activate(currentTab, false, false);
            else panels.forEach(function (p, i) { p.hidden = i !== 0; });
            say('Back to browsing');
          }
          function watchViewOpen() { return wv && !wv.hidden; }

          if (watchChip) {
            watchChip.addEventListener('click', function () {
              if (watchViewOpen()) closeWatchView(); else openWatchView();
            });
          }
          if (wvClose) wvClose.addEventListener('click', closeWatchView);

          /* Keep Watching chip / bells in sync when another hub changes the list. */
          function syncWatchFromStore() {
            paintWatch();
            if (watchViewOpen()) {
              if (!readWatch().length) closeWatchView();
              else renderWatchView();
            }
            if (typeof refilterAll === 'function') refilterAll();
          }
          function onWatchStorage(ev) {
            if (!ev || !ev.key) return;
            if (ev.key === K_TIP && ev.newValue === '1') hideAllTips();
            if (ev.key === K_WATCH || ev.key === 'll_preorder_watch' || (ev.key.indexOf && ev.key.indexOf('ll_watchlist_c_') === 0)) {
              syncWatchFromStore();
            }
          }
          document.addEventListener('ll:watchlist:change', syncWatchFromStore);
          window.addEventListener('storage', onWatchStorage);

          /* =====================================================================
             AFFINITY - which game has this browser actually been looking at?

             Everything here is read from and written to this device's own storage.
             No account, no profile, no network call. Signals, strongest first:
               explicit pick > quick-adds > card clicks > recently viewed > landing URL
          ===================================================================== */
          function termsOf(tab) {
            return (tab.getAttribute('data-terms') || '')
              .split(',').map(function (t) { return t.trim(); }).filter(Boolean);
          }

          /* Returns the game key whose terms appear in `text`, or null. */
          function classify(text) {
            if (!text) return null;
            var t = String(text).toLowerCase();
            for (var i = 0; i < tabs.length; i++) {
              var terms = termsOf(tabs[i]);
              for (var j = 0; j < terms.length; j++) {
                if (terms[j] && t.indexOf(terms[j]) > -1) return tabs[i].getAttribute('data-game');
              }
            }
            return null;
          }

          function bumpAffinity(key, n) {
            if (!key) return;
            var aff = readJSON(localStorage, K_AFF, {}) || {};
            aff[key] = Math.min((aff[key] || 0) + n, 40);
            writeJSON(localStorage, K_AFF, aff);
          }

          function pickGame() {
            var scores = {};
            function add(key, n) { if (key) scores[key] = (scores[key] || 0) + n; }

            /* 1 - an explicit choice outranks everything until it goes stale. */
            var last = readJSON(localStorage, K_LAST, null);
            var days = cfg.rememberDays || 30;
            if (last && last.g && last.ts && (Date.now() - last.ts) < days * 86400000) add(last.g, 60);

            /* 2 - accumulated interactions with this hub. */
            var aff = readJSON(localStorage, K_AFF, {}) || {};
            Object.keys(aff).forEach(function (k) { add(k, Math.min(aff[k], 20) * 2); });

            /* 3 - recently viewed products, most recent weighted heaviest. The
               handle alone is usually enough ("disney-lorcana-…"); where the
               recently-viewed section has already cached the product JSON we read
               that too, which costs nothing and is far more reliable. */
            var rv = readJSON(localStorage, K_RV, []);
            if (Object.prototype.toString.call(rv) === '[object Array]') {
              rv.slice(0, 12).forEach(function (h, i) {
                if (typeof h !== 'string') return;
                var w = 12 - i;
                add(classify(h.replace(/-/g, ' ')), w * 0.5);
                var cached = readJSON(sessionStorage, 'll_rvp_' + h, null);
                if (cached) {
                  var d = cached.p || cached.product || cached.data || cached;
                  var tags = d && d.tags;
                  var txt = [d && d.title, d && d.vendor, d && d.type,
                    (Object.prototype.toString.call(tags) === '[object Array]' ? tags.join(' ') : tags)].join(' ');
                  add(classify(txt), w);
                }
              });
            }

            /* 4 - the page they arrived on. */
            try {
              add(classify(decodeURIComponent(window.location.pathname).replace(/[-/_]/g, ' ')), 8);
            } catch (e) {}

            var bestKey = null, bestScore = 0;
            Object.keys(scores).forEach(function (k) {
              if (scores[k] > bestScore) { bestScore = scores[k]; bestKey = k; }
            });
            if (!bestKey) return { index: 0, key: null, score: 0 };

            for (var i = 0; i < tabs.length; i++) {
              if (tabs[i].getAttribute('data-game') === bestKey) {
                return { index: i, key: bestKey, score: bestScore };
              }
            }
            return { index: 0, key: null, score: 0 };
          }

          /* =====================================================================
             TABS
          ===================================================================== */
          function activate(index, focusTab, remember) {
            currentTab = index;
            /* Choosing a game leaves the watchlist view. */
            if (wv && !wv.hidden) {
              wv.hidden = true;
              if (watchChip) watchChip.setAttribute('aria-pressed', 'false');
            }
            tabs.forEach(function (t, i) {
              var on = i === index;
              t.setAttribute('aria-selected', on ? 'true' : 'false');
              t.setAttribute('tabindex', on ? '0' : '-1');
              if (on && focusTab) t.focus();
              if (on) {
                root.style.setProperty('--acc', t.getAttribute('data-acc'));
                root.style.setProperty('--acc-ink', t.getAttribute('data-acc-ink'));
                root.style.setProperty('--on-acc', t.getAttribute('data-on-acc'));
                t.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
                if (remember) {
                  writeJSON(localStorage, K_LAST, { g: t.getAttribute('data-game'), ts: Date.now() });
                  bumpAffinity(t.getAttribute('data-game'), 1);
                }
              }
            });
            panels.forEach(function (p, i) { p.hidden = i !== index; });
            refreshLanes();
            var label = tabs[index] ? tabs[index].getAttribute('data-label') : '';
            if (label) say(label + ' shown');
            if (typeof updateFindScope === 'function') updateFindScope();
            if (findInput && findInput.value && typeof renderFind === 'function') {
              clearTimeout(findTimer);
              findTimer = setTimeout(function () { renderFind(findInput.value); }, 40);
            }
            if (typeof refreshNavMarks === 'function') refreshNavMarks();

            /* Tell the rest of the page which game is showing. Sections that sit
               outside this one - the brand advert strip - follow the tabs without
               needing to reach into this section's markup or duplicate the game
               list. Fired last, so listeners see the finished state rather than a
               half-applied one. */
            var t = tabs[index];
            if (t) {
              try {
                document.dispatchEvent(new CustomEvent('ll:hub:game', {
                  detail: {
                    game:   t.getAttribute('data-game'),
                    label:  t.getAttribute('data-label'),
                    acc:    t.getAttribute('data-acc'),
                    accInk: t.getAttribute('data-acc-ink'),
                    onAcc:  t.getAttribute('data-on-acc'),
                    index:  index
                  }
                }));
              } catch (e) {}
            }
          }

          tabs.forEach(function (t, i) {
            t.addEventListener('click', function () { activate(i, false, true); });
            t.addEventListener('keydown', function (e) {
              var k = e.key, n = null;
              if (k === 'ArrowRight') n = (i + 1) % tabs.length;
              else if (k === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
              else if (k === 'Home') n = 0;
              else if (k === 'End') n = tabs.length - 1;
              if (n !== null) { e.preventDefault(); activate(n, true, true); }
            });
          });

          /* =====================================================================
             PER-LANE: chip filtering, rail navigation, stage stepper
          ===================================================================== */
          root.querySelectorAll('[data-lane]').forEach(function (lane) {
            var track = lane.querySelector('[data-track]');
            if (!track) return;
            var rail = lane.querySelector('[data-rail]');
            var nav = lane.querySelector('[data-nav]');
            var prev = lane.querySelector('[data-prev]');
            var next = lane.querySelector('[data-next]');
            var empty = lane.querySelector('[data-empty]');
            var chips = Array.prototype.slice.call(lane.querySelectorAll('[data-chip]'));
            var cards = Array.prototype.slice.call(lane.querySelectorAll('[data-card]'));

            /* Tiles are a union filter (Sleeves + Binders); chips are single-select
               with an explicit All. Both resolve to the same token list. */
            var isTiles = lane.querySelector('.lltc__tiles') !== null;
            var active = [];

            function tokensOf(card) {
              /* counts() asks every chip about every card, so this ran
                 cards x chips times per repaint and re-split the same
                 attribute each time. The tokens never change after render. */
              var t = card.__llTok;
              if (!t) {
                t = (card.getAttribute('data-tokens') || '').split(/\s+/).filter(Boolean);
                card.__llTok = t;
              }
              return t;
            }
            function apply() {
              var visible = 0;
              cards.forEach(function (card) {
                var show = !active.length;
                if (!show) {
                  var t = tokensOf(card);
                  for (var i = 0; i < active.length; i++) {
                    if (t.indexOf(active[i]) > -1) { show = true; break; }
                  }
                }
                card.hidden = !show;
                if (show) visible++;
              });
              if (empty) empty.setAttribute('data-show', visible === 0 ? '1' : '0');
              updateRail();
            }
            function counts() {
              var live = 0;
              chips.forEach(function (chip) {
                var token = chip.getAttribute('data-token');
                var out = chip.querySelector('[data-chip-n]');
                var n = token === 'all'
                  ? cards.length
                  : cards.filter(function (c) { return tokensOf(c).indexOf(token) > -1; }).length;
                if (out) out.textContent = n ? (isTiles ? n + ' items' : ' ' + n) : (isTiles ? 'None yet' : '');
                if (token === 'all') return;
                /* Removed, not greyed out. A chip nobody can press is a dead control
                   taking up the width of a live one, and a row of them reads as a
                   broken filter rather than a stock level. It comes back on its own
                   the moment the lane holds one of that kind. */
                chip.hidden = n === 0;
                chip.disabled = n === 0;
                if (n > 0) live++;
              });
              /* Nothing left to choose between, so the lone "All" goes too. */
              var group = lane.querySelector('.lltc__chips, .lltc__tiles');
              if (group) group.hidden = live === 0;
            }
            function paintChips() {
              chips.forEach(function (chip) {
                var token = chip.getAttribute('data-token');
                var on = token === 'all' ? active.length === 0 : active.indexOf(token) > -1;
                chip.setAttribute('aria-pressed', on ? 'true' : 'false');
              });
            }
            chips.forEach(function (chip) {
              chip.addEventListener('click', function () {
                if (chip.disabled) return;
                var token = chip.getAttribute('data-token');
                if (token === 'all') {
                  active = [];
                } else if (isTiles) {
                  var at = active.indexOf(token);
                  if (at > -1) active.splice(at, 1); else active.push(token);
                } else {
                  active = (active.length === 1 && active[0] === token) ? [] : [token];
                }
                paintChips();
                apply();
                if (rail) rail.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' });
              });
            });

            function updateRail() {
              if (!rail || !rail.clientWidth) return;   /* hidden panels measure zero */
              var max = rail.scrollWidth - rail.clientWidth;
              if (max <= 4) {
                rail.setAttribute('data-edge', 'none');
                if (nav) nav.hidden = true;
                return;
              }
              if (nav) nav.hidden = false;
              var x = rail.scrollLeft;
              var atStart = x <= 2, atEnd = x >= max - 2;
              rail.setAttribute('data-edge', atStart ? 'right' : (atEnd ? 'left' : 'both'));
              if (prev) prev.disabled = atStart;
              if (next) next.disabled = atEnd;
            }

            if (rail) {
              rail.addEventListener('scroll', updateRail, { passive: true });
              [[prev, -1], [next, 1]].forEach(function (pair) {
                if (!pair[0]) return;
                pair[0].addEventListener('click', function () {
                  rail.scrollBy({
                    left: pair[1] * Math.max(200, Math.round(rail.clientWidth * 0.85)),
                    behavior: reduce ? 'auto' : 'smooth'
                  });
                });
              });
              if ('ResizeObserver' in window) {
                var ro = new ResizeObserver(updateRail);
                ro.observe(rail);
                observers.push(ro);
              }
              railUpdaters.push(updateRail);
            }

            counts();
            paintChips();
            apply();
            laneFilters.push(apply);
          });

          function refreshLanes() { railUpdaters.forEach(function (f) { f(); }); }

          /* ---- era / set sub-nav: same edge-fade + arrows as the lane rails ---- */
          root.querySelectorAll('[data-erawrap]').forEach(function (wrap) {
            var rail = wrap.querySelector('[data-erarail]');
            var nav = wrap.querySelector('[data-eranav]');
            var prev = wrap.querySelector('[data-eraprev]');
            var next = wrap.querySelector('[data-eranext]');
            if (!rail) return;

            function update() {
              if (!rail.clientWidth) return;      /* hidden panel measures zero */
              var max = rail.scrollWidth - rail.clientWidth;
              if (max <= 4) {
                rail.setAttribute('data-edge', 'none');
                if (nav) nav.hidden = true;
                return;
              }
              if (nav) nav.hidden = false;
              var x = rail.scrollLeft;
              var atStart = x <= 2, atEnd = x >= max - 2;
              rail.setAttribute('data-edge', atStart ? 'right' : (atEnd ? 'left' : 'both'));
              if (prev) prev.disabled = atStart;
              if (next) next.disabled = atEnd;
            }
            rail.addEventListener('scroll', update, { passive: true });
            [[prev, -1], [next, 1]].forEach(function (pair) {
              if (!pair[0]) return;
              pair[0].addEventListener('click', function () {
                rail.scrollBy({
                  left: pair[1] * Math.max(200, Math.round(rail.clientWidth * 0.8)),
                  behavior: reduce ? 'auto' : 'smooth'
                });
              });
            });
            if ('ResizeObserver' in window) {
              var ro = new ResizeObserver(update);
              ro.observe(rail);
              observers.push(ro);
            }
            /* Re-measured on tab switch, since a hidden panel reports zero width. */
            railUpdaters.push(update);
            update();
          });

          /* ---- stage stepper, one per game panel ---- */
          panels.forEach(function (panel) {
            var steps = Array.prototype.slice.call(panel.querySelectorAll('[data-step]'));
            if (!steps.length) return;
            var lanes = steps.map(function (el) { return panel.querySelector('#' + el.getAttribute('data-target')); });

            function mark(i) {
              steps.forEach(function (el, j) { el.setAttribute('aria-current', i === j ? 'true' : 'false'); });
            }
            steps.forEach(function (step, i) {
              step.addEventListener('click', function () {
                if (!lanes[i]) return;
                lanes[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
                mark(i);
              });
            });
            if ('IntersectionObserver' in window) {
              /* Top-weighted band so the step flips at reading position, not when a
                 lane merely grazes the viewport edge. */
              var io = new IntersectionObserver(function (entries) {
                entries.forEach(function (en) {
                  if (!en.isIntersecting) return;
                  var i = lanes.indexOf(en.target);
                  if (i > -1) mark(i);
                });
              }, { rootMargin: '-20% 0px -60% 0px', threshold: 0 });
              lanes.forEach(function (l) { if (l) io.observe(l); });
              observers.push(io);
            }
          });

          /* =====================================================================
             INTERACTIONS THAT TEACH THE HUB
          ===================================================================== */
          function gameOfCard(card) {
            var panel = card.closest('[data-panel]');
            return panel ? panel.getAttribute('data-game') : null;
          }

          root.addEventListener('click', function (e) {
            var card = e.target.closest('[data-card]');
            if (card && root.contains(card) && !e.target.closest('[data-add]') && !e.target.closest('[data-watch]')) {
              bumpAffinity(gameOfCard(card), 1);
            }
          });

          root.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-add]');
            if (!btn || !root.contains(btn)) return;
            e.preventDefault();
            var card = btn.closest('[data-card]');
            var id = card && card.getAttribute('data-vid');
            if (!id) { if (card) window.location.href = card.getAttribute('data-url'); return; }

            btn.classList.add('is-busy');
            var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            fetch(rootUrl + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
            })
              .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
              .then(function (res) {
                if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add');
                bumpAffinity(gameOfCard(card), 4);
                showToast(cfg.added || 'Added to your cart', cfg.cartUrl);
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
              })
              .catch(function (err) { showToast(err.message || 'Sorry, that could not be added', card.getAttribute('data-url')); })
              .then(function () { btn.classList.remove('is-busy'); });
          });

          /* =====================================================================
             OPENING TAB
          ===================================================================== */
          var notice = root.querySelector('[data-auto]');
          var noticeName = root.querySelector('[data-auto-game]');
          var noticeClear = root.querySelector('[data-auto-clear]');

          if (tabs.length) {
            var chosen = { index: 0, key: null, score: 0 };
            if (cfg.autoSelect) {
              try { chosen = pickGame(); } catch (e) { chosen = { index: 0, key: null, score: 0 }; }
            }
            activate(chosen.index, false, false);

            /* Only say something when the pick actually moved them off the first
               tab - announcing "opened on Pokémon" when Pokémon is first is noise. */
            if (notice && chosen.index > 0 && chosen.score > 0) {
              if (noticeName) noticeName.textContent = tabs[chosen.index].getAttribute('data-label');
              notice.setAttribute('data-on', '1');
            }
          }

          paintWatch();

          if (noticeClear) {
            noticeClear.addEventListener('click', function () {
              try { localStorage.removeItem(K_AFF); localStorage.removeItem(K_LAST); } catch (e) {}
              if (notice) notice.setAttribute('data-on', '0');
              activate(0, false, false);
              say('Reset. Showing ' + (tabs[0] ? tabs[0].getAttribute('data-label') : 'the first game'));
            });
          }

          /* =====================================================================
             HUB SEARCH - full selected-TCG catalogue via Predictive Search
          ===================================================================== */
          var findWrap = root.querySelector('[data-find]');
          var findInput = root.querySelector('[data-find-input]');
          var findDrop = root.querySelector('[data-find-drop]');
          var findList = root.querySelector('[data-find-list]');
          var findHint = root.querySelector('[data-find-hint]');
          var findEmpty = root.querySelector('[data-find-empty]');
          var findClear = root.querySelector('[data-find-clear]');
          var findScope = root.querySelector('[data-find-scope]');
          var findMore = root.querySelector('[data-find-more]');
          var findTimer = null;
          var findActive = -1;
          var findHits = [];
          var findPulseTimer = null;
          var findReq = 0;

          function normFind(s) {
            return String(s || '')
              .toLowerCase()
              .replace(/[éèêë]/g, 'e').replace(/[áàâä]/g, 'a').replace(/[íìîï]/g, 'i')
              .replace(/[óòôö]/g, 'o').replace(/[úùûü]/g, 'u').replace(/ñ/g, 'n')
              .replace(/[^a-z0-9\s\/\-:]/g, ' ')
              .replace(/\s+/g, ' ')
              .trim();
          }
          function splitAttr(el, name) {
            return (el && el.getAttribute(name) || '')
              .split(',').map(function (t) { return normFind(t); }).filter(Boolean);
          }
          function activeFindTab() {
            return tabs[currentTab] || tabs[0] || null;
          }
          function updateFindScope() {
            var tab = activeFindTab();
            if (!tab) return;
            var label = tab.getAttribute('data-label') || 'this TCG';
            if (findInput) {
              var ph = String(cfg.searchPlaceholderGame || 'Search all %game%…').replace('%game%', label);
              findInput.placeholder = ph;
              findInput.setAttribute('aria-label', 'Search all ' + label);
            }
            if (findScope) {
              findScope.textContent = String(cfg.searchScope || 'Searching all %game%').replace('%game%', label);
            }
            if (findMore) {
              var curl = tab.getAttribute('data-collection-url') || '';
              findMore.textContent = (cfg.searchMore || 'Browse full collection') + (label ? ' · ' + label : '');
              if (curl) {
                findMore.href = curl;
                findMore.hidden = false;
              } else {
                findMore.hidden = true;
              }
            }
          }
          function productBelongsToGame(product, tab) {
            if (!product || !tab) return false;
            var terms = splitAttr(tab, 'data-terms');
            var tags = splitAttr(tab, 'data-tags');
            var types = splitAttr(tab, 'data-types');
            var vendors = splitAttr(tab, 'data-vendors');
            var collections = splitAttr(tab, 'data-collections');
            var type = normFind(product.type || product.product_type || '');
            var vendor = normFind(product.vendor || '');
            var title = normFind(product.title || '');
            var url = normFind(product.url || '');
            var tagList = [];
            if (Object.prototype.toString.call(product.tags) === '[object Array]') {
              tagList = product.tags.map(normFind);
            } else if (product.tags) {
              tagList = String(product.tags).split(',').map(normFind);
            }
            var i;
            for (i = 0; i < types.length; i++) {
              if (types[i] && type && (type === types[i] || type.indexOf(types[i]) > -1)) return true;
            }
            for (i = 0; i < tags.length; i++) {
              if (tags[i] && tagList.indexOf(tags[i]) > -1) return true;
            }
            for (i = 0; i < vendors.length; i++) {
              if (vendors[i] && vendor.indexOf(vendors[i]) > -1) return true;
            }
            for (i = 0; i < collections.length; i++) {
              if (collections[i] && url.indexOf('/collections/' + collections[i]) > -1) return true;
            }
            /* Fallback: title / url term match - same spirit as the hub game filter. */
            for (i = 0; i < terms.length; i++) {
              if (!terms[i] || terms[i].length < 3) continue;
              if (title.indexOf(terms[i]) > -1 || url.indexOf(terms[i].replace(/\s+/g, '-')) > -1) return true;
              if (type.indexOf(terms[i]) > -1 || vendor.indexOf(terms[i]) > -1) return true;
              if (tagList.some(function (t) { return t.indexOf(terms[i]) > -1; })) return true;
            }
            return false;
          }
          function scoreProduct(product, q) {
            var title = normFind(product.title || '');
            var score = 0;
            if (title === q) score = 200;
            else if (title.indexOf(q) === 0) score = 160;
            else if ((' ' + title + ' ').indexOf(' ' + q + ' ') > -1) score = 130;
            else if (title.indexOf(q) > -1) score = 100;
            else score = 50;
            if (product.available === false) score -= 8;
            return score;
          }
          function hubCardForHandle(handle, url) {
            if (handle) {
              var byHandle = root.querySelector('[data-card][data-handle="' + handle.replace(/"/g, '') + '"]');
              if (byHandle) return byHandle;
            }
            if (url) {
              var cards = root.querySelectorAll('[data-card][data-url]');
              for (var i = 0; i < cards.length; i++) {
                if (cards[i].getAttribute('data-url') === url) return cards[i];
              }
            }
            return null;
          }
          function openFindDrop(open) {
            if (!findDrop || !findInput) return;
            findDrop.hidden = !open;
            findDrop.setAttribute('data-open', open ? '1' : '0');
            findInput.setAttribute('aria-expanded', open ? 'true' : 'false');
          }
          function paintFindActive() {
            if (!findList) return;
            Array.prototype.forEach.call(findList.querySelectorAll('[data-find-item]'), function (btn, i) {
              btn.setAttribute('aria-selected', i === findActive ? 'true' : 'false');
            });
          }
          function paintFindHits(gameLabel) {
            if (!findList) return;
            if (findHint) findHint.hidden = true;
            if (findScope) findScope.hidden = false;
            if (!findHits.length) {
              findList.hidden = true;
              findList.innerHTML = '';
              if (findEmpty) findEmpty.hidden = false;
              openFindDrop(true);
              say('No matches in ' + (gameLabel || 'this TCG'));
              return;
            }
            if (findEmpty) findEmpty.hidden = true;
            findList.hidden = false;
            findList.innerHTML = findHits.map(function (item, i) {
              var meta = [item.game, item.type].filter(Boolean).join(' · ');
              var thumb = item.img
                ? '<img class="lltc__find-thumb" src="' + String(item.img).replace(/"/g, '&quot;') + '" alt="" width="40" height="40" loading="lazy">'
                : '<span class="lltc__find-thumb lltc__find-thumb--empty" aria-hidden="true">TCG</span>';
              return '<li role="presentation">' +
                '<button type="button" class="lltc__find-item" role="option" data-find-item="' + i + '" aria-selected="false">' +
                  thumb +
                  '<span><span class="lltc__find-name">' + String(item.title || '').replace(/</g, '&lt;') + '</span>' +
                  (meta ? '<span class="lltc__find-meta">' + String(meta).replace(/</g, '&lt;') + '</span>' : '') +
                  '</span></button></li>';
            }).join('');
            openFindDrop(true);
            say(findHits.length + ' match' + (findHits.length === 1 ? '' : 'es') + ' in ' + (gameLabel || 'this TCG'));
          }
          function fetchPredictive(query, tab) {
            var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            var types = splitAttr(tab, 'data-types');
            var tags = splitAttr(tab, 'data-tags');
            var label = tab.getAttribute('data-label') || '';
            /* Prefer Shopify field operators so results lean into this TCG's inventory. */
            function fieldOp(key, val) {
              if (!val) return '';
              return /\s/.test(val) ? (' ' + key + ':"' + val + '"') : (' ' + key + ':' + val);
            }
            var scoped = query;
            if (types[0]) scoped = query + fieldOp('product_type', types[0]);
            else if (tags[0]) scoped = query + fieldOp('tag', tags[0]);
            else if (label) scoped = query + ' ' + label;

            function req(q) {
              var url = rootUrl + 'search/suggest.json?q=' + encodeURIComponent(q) +
                '&resources[type]=product' +
                '&resources[limit]=20' +
                '&resources[options][unavailable_products]=last' +
                '&resources[options][fields]=title,product_type,vendor,variants.title,tag';
              return fetch(url, { headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.ok ? r.json() : { resources: { results: { products: [] } } }; })
                .catch(function () { return { resources: { results: { products: [] } } }; });
            }

            return req(scoped).then(function (data) {
              var products = (((data || {}).resources || {}).results || {}).products || [];
              var filtered = products.filter(function (p) { return productBelongsToGame(p, tab); });
              if (filtered.length) return filtered;
              /* Broaden: plain query, still filtered to this game client-side. */
              return req(query).then(function (data2) {
                var products2 = (((data2 || {}).resources || {}).results || {}).products || [];
                return products2.filter(function (p) { return productBelongsToGame(p, tab); });
              });
            });
          }
          function renderFind(q) {
            if (!findList || !findDrop) return;
            var tab = activeFindTab();
            var query = normFind(q);
            var gameLabel = tab ? (tab.getAttribute('data-label') || '') : '';
            findHits = [];
            findActive = -1;
            if (findClear) findClear.setAttribute('data-on', query ? '1' : '0');
            updateFindScope();

            if (!query) {
              findList.hidden = true;
              findList.innerHTML = '';
              if (findHint) findHint.hidden = false;
              if (findEmpty) findEmpty.hidden = true;
              if (findScope) findScope.hidden = true;
              if (findMore) {
                var curl = tab && tab.getAttribute('data-collection-url');
                findMore.hidden = !curl;
              }
              openFindDrop(document.activeElement === findInput);
              return;
            }
            if (!tab) {
              if (findHint) findHint.hidden = true;
              if (findEmpty) findEmpty.hidden = false;
              openFindDrop(true);
              return;
            }

            if (findHint) findHint.hidden = true;
            if (findScope) findScope.hidden = false;
            if (findEmpty) findEmpty.hidden = true;
            findList.hidden = false;
            findList.innerHTML = '<li class="lltc__find-hint" style="list-style:none">Searching ' + String(gameLabel).replace(/</g, '&lt;') + '…</li>';
            openFindDrop(true);

            var reqId = ++findReq;
            fetchPredictive(query, tab).then(function (products) {
              if (reqId !== findReq) return;
              var ranked = (products || []).map(function (p) {
                return { product: p, score: scoreProduct(p, query) };
              }).sort(function (a, b) { return b.score - a.score; });

              var seen = {};
              findHits = [];
              ranked.forEach(function (r) {
                var p = r.product;
                var handle = p.handle || '';
                var key = handle || p.url || p.title;
                if (seen[key]) return;
                seen[key] = 1;
                var img = '';
                if (p.image) img = typeof p.image === 'string' ? p.image : (p.image + '');
                if (!img && p.featured_image) img = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.url || '');
                findHits.push({
                  title: p.title || '',
                  url: p.url || (handle ? ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'products/' + handle : ''),
                  handle: handle,
                  img: img,
                  type: p.type || p.product_type || '',
                  game: gameLabel,
                  remote: true
                });
              });
              findHits = findHits.slice(0, 8);

              /* Keep collection browse link useful while searching. */
              if (findMore) {
                var base = tab.getAttribute('data-collection-url') || '';
                if (base) {
                  findMore.href = base;
                  findMore.hidden = false;
                } else {
                  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
                  findMore.href = rootUrl + 'search?type=product&q=' + encodeURIComponent(q);
                  findMore.hidden = false;
                }
              }
              paintFindHits(gameLabel);
            });
          }
          function pulseCard(card) {
            root.querySelectorAll('.lltc__card.is-find-hit').forEach(function (c) { c.classList.remove('is-find-hit'); });
            if (!card) return;
            card.classList.add('is-find-hit');
            clearTimeout(findPulseTimer);
            findPulseTimer = setTimeout(function () { card.classList.remove('is-find-hit'); }, 2600);
          }
          function goToFindHit(item) {
            if (!item) return;
            if (watchViewOpen()) closeWatchView();
            var card = hubCardForHandle(item.handle, item.url);
            if (card) {
              var panel = card.closest('[data-panel]');
              var panelIndex = panels.indexOf(panel);
              if (panelIndex > -1) activate(panelIndex, false, true);
              card.hidden = false;
              try {
                card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', inline: 'center', block: 'center' });
              } catch (e) {}
              pulseCard(card);
              openFindDrop(false);
              if (findInput) findInput.blur();
              say((item.title || 'Product') + ' found');
              return;
            }
            if (item.url) {
              window.location.href = item.url;
              return;
            }
          }

          if (findInput && cfg.enableSearch !== false) {
            updateFindScope();
            findInput.addEventListener('input', function () {
              clearTimeout(findTimer);
              findTimer = setTimeout(function () { renderFind(findInput.value); }, 160);
            });
            findInput.addEventListener('focus', function () {
              updateFindScope();
              renderFind(findInput.value);
            });
            findInput.addEventListener('keydown', function (e) {
              if (e.key === 'ArrowDown') {
                if (!findHits.length) return;
                e.preventDefault();
                findActive = (findActive + 1) % findHits.length;
                paintFindActive();
              } else if (e.key === 'ArrowUp') {
                if (!findHits.length) return;
                e.preventDefault();
                findActive = (findActive - 1 + findHits.length) % findHits.length;
                paintFindActive();
              } else if (e.key === 'Enter') {
                if (!findHits.length) return;
                e.preventDefault();
                goToFindHit(findHits[findActive > -1 ? findActive : 0]);
              } else if (e.key === 'Escape') {
                e.preventDefault();
                findInput.value = '';
                renderFind('');
                openFindDrop(false);
                findInput.blur();
              }
            });
            if (findList) {
              findList.addEventListener('click', function (e) {
                var btn = e.target.closest('[data-find-item]');
                if (!btn) return;
                var i = Number(btn.getAttribute('data-find-item'));
                if (!isNaN(i) && findHits[i]) goToFindHit(findHits[i]);
              });
            }
            if (findClear) {
              findClear.addEventListener('click', function () {
                findInput.value = '';
                renderFind('');
                findInput.focus();
              });
            }
            document.addEventListener('click', function findDocClose(e) {
              if (!findWrap || findWrap.contains(e.target)) return;
              openFindDrop(false);
            });
          }

          /* =====================================================================
             NAV TIP - passive, once; numbered markers stay until Got it
          ===================================================================== */
          var K_NAV_TIP = 'll_tcg_nav_tip_seen';
          var navTip = root.querySelector('[data-nav-tip]');
          var navTipDismiss = root.querySelector('[data-nav-tip-dismiss]');
          var navTipObserver = null;
          var navMarksActive = false;
          function navTipSeen() {
            try {
              return localStorage.getItem(K_NAV_TIP) === '1' || localStorage.getItem('ll_tcg_nav_guide_seen') === '1';
            } catch (e) { return true; }
          }
          function clearNavMarks() {
            root.querySelectorAll('.is-nav-mark').forEach(function (el) {
              el.classList.remove('is-nav-mark');
            });
            root.querySelectorAll('.lltc__nav-mark').forEach(function (el) {
              el.parentNode && el.parentNode.removeChild(el);
            });
            navMarksActive = false;
          }
          function pinNavMark(el, n) {
            if (!el) return;
            el.classList.add('is-nav-mark');
            var badge = document.createElement('span');
            badge.className = 'lltc__nav-mark';
            badge.setAttribute('aria-hidden', 'true');
            badge.textContent = String(n);
            el.appendChild(badge);
          }
          function refreshNavMarks() {
            if (!navMarksActive) return;
            clearNavMarks();
            navMarksActive = true;
            /* Numbers match the Quick tip legend: 1 tabs, 2 sets, 3 search */
            var tabsEl = root.querySelector('[data-tablist]');
            var panel = panels[currentTab] || root.querySelector('[data-panel]:not([hidden])') || panels[0];
            var setsEl = panel ? panel.querySelector('[data-erawrap]') : null;
            var findEl = root.querySelector('[data-find]');
            pinNavMark(tabsEl, 1);
            pinNavMark(setsEl, 2);
            pinNavMark(findEl, 3);
          }
          function showNavMarks() {
            navMarksActive = true;
            refreshNavMarks();
          }
          function markNavTipSeen() {
            try { localStorage.setItem(K_NAV_TIP, '1'); } catch (e) {}
            if (navTip) navTip.hidden = true;
            clearNavMarks();
            if (navTipObserver) { navTipObserver.disconnect(); navTipObserver = null; }
          }
          function revealNavTip() {
            if (!navTip || navTipSeen()) return;
            navTip.hidden = false;
            showNavMarks();
          }
          if (navTip && cfg.enableNavTip !== false && !navTipSeen()) {
            if ('IntersectionObserver' in window) {
              navTipObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                  if (!entry.isIntersecting) return;
                  revealNavTip();
                  if (navTipObserver) { navTipObserver.disconnect(); navTipObserver = null; }
                });
              }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
              navTipObserver.observe(root);
              observers.push(navTipObserver);
            } else {
              revealNavTip();
            }
          }
          if (navTipDismiss) navTipDismiss.addEventListener('click', markNavTipSeen);

          window.addEventListener('resize', refreshLanes);

          root.lltcDestroy = function () {
            observers.forEach(function (o) { o.disconnect(); });
            window.removeEventListener('resize', refreshLanes);
            document.removeEventListener('ll:watchlist:change', syncWatchFromStore);
            window.removeEventListener('storage', onWatchStorage);
            clearTimeout(toastTimer);
            clearTimeout(findTimer);
            clearTimeout(findPulseTimer);
            clearNavMarks();
            root.dataset.lltcReady = '';
          };
        }

        function find() { return document.querySelector('[data-lltc-root][data-section-id="' + ROOT_ID + '"]'); }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function () { boot(find()); });
        } else {
          boot(find());
        }
        document.addEventListener('shopify:section:load', function (e) {
          if (String(e.detail.sectionId) !== ROOT_ID) return;
          boot(find());
        });
        document.addEventListener('shopify:section:unload', function (e) {
          if (String(e.detail.sectionId) !== ROOT_ID) return;
          var el = find();
          if (el && el.lltcDestroy) el.lltcDestroy();
        });
    }

    function initOnce(id) {
      if (!id || inited[id]) return;
      inited[id] = true;
      initInstance(id);
    }

    function bootAll() {
      var roots = document.querySelectorAll("[data-lltc-root][data-section-id]");
      for (var i = 0; i < roots.length; i++) initOnce(roots[i].getAttribute("data-section-id"));
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bootAll);
    } else {
      bootAll();
    }

    /* A section added in the theme editor arrives after first boot. Each
       instance registers its own load/unload handlers inside initInstance,
       so this only has to catch ids that have never been seen. */
    document.addEventListener("shopify:section:load", bootAll);
    document.addEventListener("shopify:section:unload", function (e) {
      var id = e && e.detail && String(e.detail.sectionId);
      if (id) delete inited[id];
    });
  })();

  /* ---- block 2 of 2, extracted verbatim ---- */
  (function () {
    var inited = {};

    function initInstance(ROOT_ID) {
      /* Slide affordance: an edge fade that follows real scroll position, plus a
           progress readout so "there is more" is unmistakable. Additive only - it
           reads scroll offsets and writes one attribute. */
        var SELS = [".lltc__grid", ".lltc__tiles"];
        var LABEL = "Swipe cards";
        var root = document.getElementById('shopify-section-' + ROOT_ID);
        if (!root) return;

        var mq = window.matchMedia('(max-width: 700px)');

        function railList() {
          var out = [];
          for (var i = 0; i < SELS.length; i++) {
            var found = root.querySelectorAll(SELS[i]);
            for (var j = 0; j < found.length; j++) out.push(found[j]);
          }
          return out;
        }

        function barFor(el) {
          var b = el.nextElementSibling;
          if (b && b.className === 'll-swipebar') return b;
          b = document.createElement('span');
          b.className = 'll-swipebar';
          b.setAttribute('aria-hidden', 'true');
          var lab = document.createElement('b');
          lab.textContent = LABEL;
          var track = document.createElement('u');
          track.appendChild(document.createElement('i'));
          b.appendChild(lab);
          b.appendChild(track);
          if (el.parentNode) el.parentNode.insertBefore(b, el.nextSibling);
          return b;
        }

        function sync(el) {
          var bar = barFor(el);
          var over = el.scrollWidth - el.clientWidth;
          if (!mq.matches || over <= 4) {
            el.removeAttribute('data-swipe');
            bar.hidden = true;
            return;
          }
          bar.hidden = false;
          var left = el.scrollLeft > 4;
          var right = el.scrollLeft < over - 4;
          el.setAttribute('data-swipe', left && right ? 'both' : (left ? 'left' : 'right'));

          var w = Math.max(18, (el.clientWidth / el.scrollWidth) * 100);
          var frac = el.scrollLeft / over;
          var thumb = bar.querySelector('i');
          thumb.style.width = w.toFixed(1) + '%';
          thumb.style.transform = 'translateX(' + (((100 - w) / w) * 100 * frac).toFixed(1) + '%)';
        }

        function boot() {
          railList().forEach(function (el) {
            if (el.__llSwipe) { sync(el); return; }
            el.__llSwipe = 1;
            var raf = 0;
            el.addEventListener('scroll', function () {
              if (raf) return;
              raf = requestAnimationFrame(function () { raf = 0; sync(el); });
            }, { passive: true });
            if (window.ResizeObserver) new ResizeObserver(function () { sync(el); }).observe(el);
            sync(el);
          });
        }

        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
        else boot();
        window.addEventListener('resize', boot);
        window.addEventListener('load', boot);
        document.addEventListener('shopify:section:load', boot);
    }

    function initOnce(id) {
      if (!id || inited[id]) return;
      inited[id] = true;
      initInstance(id);
    }

    function bootAll() {
      var roots = document.querySelectorAll("[data-lltc-root][data-section-id]");
      for (var i = 0; i < roots.length; i++) initOnce(roots[i].getAttribute("data-section-id"));
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bootAll);
    } else {
      bootAll();
    }

    /* A section added in the theme editor arrives after first boot. Each
       instance registers its own load/unload handlers inside initInstance,
       so this only has to catch ids that have never been seen. */
    document.addEventListener("shopify:section:load", bootAll);
    document.addEventListener("shopify:section:unload", function (e) {
      var id = e && e.detail && String(e.detail.sectionId);
      if (id) delete inited[id];
    });
  })();
})();
